import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

// DSA Pages
import { Home } from "../pages/Home";
import { LeadReport } from "../pages/LeadReport";
import { Commission } from "../pages/Commissions";
import { Profile } from "../pages/Profile";

// CRM Pages
import { CRMDSAUser } from "../pages/CRMDSAUser";
import { CRMDSAUserDetails } from "../pages/CRMDSAUserDetails";
import { Logout } from "../pages/Auth";
import { UploadedLeads } from "../pages/UploadedLeads";

import Agreement from "../pages/Agreement/Agreement";
import Hold from "../pages/Hold/Hold";
import QRCode from "../pages/QRCode/QRCode";

import AgentLists from "../pages/FieldAgentModule/AgentLists";
import AgentProfile from "../pages/FieldAgentModule/AgentProfile";
import AgentSummary from "../pages/FieldAgentModule/AgentSummary";
import AgentHome from "../pages/FieldAgentModule/AgentHome";
import AgentLeadReport from "../pages/FieldAgentModule/AgentLeadReport";

export default function DashboardRoutes() {
  const { user } = useSelector((state) => state.user);

  // console.log("user--------------->>>>>>>>", user);

  return (
    <Routes>
      {user?.role === "DSA" && (
        <>
          <Route path="/" element={<Home />} />
          <Route path="/lead-report" element={<LeadReport />} />
        </>
      )}

      {user?.role === "Field-Agent" && (
        <>
          <Route path="/" element={<AgentHome />} />
          <Route path="/lead-report" element={<AgentLeadReport />} />
        </>
      )}

      {user?.role === "Admin" && (
        <>
          <Route path="/" element={<CRMDSAUser />} />
          <Route path="/:id" element={<CRMDSAUserDetails />} />
          <Route path="/field-agents" element={<AgentLists />} />
          <Route path="/field-agent-summary/:id" element={<AgentSummary />} />
        </>
      )}

      <Route path="/commission" element={<Commission />} />
      <Route path="/uploaded-leads" element={<UploadedLeads />} />
      <Route path="/agreement" element={<Agreement />} />
      <Route path="/hold" element={<Hold />} />

      <Route path="/field-agent-profile" element={<AgentProfile />} />
      <Route path="/profile" element={<Profile />} />

      <Route path="/qr-code" element={<QRCode />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  );
}
